import React, { useEffect, useState } from 'react';
import MapClockOutlineIcon from 'mdi-react/MapClockOutlineIcon';
import { useDispatch, useSelector } from 'react-redux';
import { v1 as uuid } from 'uuid';

import { Popover } from '@xcritical/popover';
import {
  filterSelector,
  IStateFilter,
  xcriticalFiltersChangeFilter,
  xcriticalFiltersRemoveFilter,
} from '@xcritical/filter';

import { IconButton } from '@crm-framework/icon-button';
import { gridSelector, IGridFilter } from '@crm-framework/grid';

import { WrapperItem } from '../styles';

import { TimeZoneSelect } from './TimeZoneSelect';
import { TIMEZONE_FIELD_NAME } from './consts';

const getIsDateFilter = (filters: IGridFilter[]) => (filter: IStateFilter) => {
  const type = filters.find((elem) => elem.field === filter.column)?.type;

  return type === 'Date';
};

let timeZoneFieldKey = uuid();

export const TimeZonePopover: React.FC<{ dashboardName: string }> = ({
  dashboardName,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { filters } = useSelector((state) =>
    gridSelector(state, dashboardName)
  );

  const { drafts, applied } = useSelector((state) =>
    filterSelector(state, dashboardName)
  );

  const timeZoneFilter = drafts.find(
    (item) => item.column === TIMEZONE_FIELD_NAME
  );

  const isAddedDateFilter =
    !!drafts.find(getIsDateFilter(filters)) ||
    !!applied.find(getIsDateFilter(filters));

  const withTimeZoneFilter = filters.find(
    ({ field }) => field === TIMEZONE_FIELD_NAME
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (isAddedDateFilter && withTimeZoneFilter) {
      if (timeZoneFilter) {
        if (timeZoneFieldKey !== timeZoneFilter.key) {
          timeZoneFieldKey = timeZoneFilter.key;
        }

        if (!timeZoneFilter.condition)
          dispatch(
            xcriticalFiltersChangeFilter(dashboardName, {
              field: 'condition',
              guid: timeZoneFieldKey,
              value: 'equalsTo',
              valueType: 'Enum',
            })
          );

        if (!timeZoneFilter.value)
          dispatch(
            xcriticalFiltersChangeFilter(dashboardName, {
              field: 'value',
              guid: timeZoneFieldKey,
              value: 'UTC',
            })
          );
      }
    } else {
      dispatch(
        xcriticalFiltersRemoveFilter(dashboardName, {
          guid: timeZoneFilter?.key,
          name: timeZoneFilter?.column,
        })
      );
    }
  }, [timeZoneFilter, withTimeZoneFilter, isAddedDateFilter]);

  if (!withTimeZoneFilter) return null;

  return (
    <WrapperItem>
      <Popover
        visible={isOpen}
        onOutsideClick={() => setIsOpen(false)}
        positionFixed
        appearance="form"
        autoContentSize
        trigger="click"
        position="bottom left"
        content={
          <TimeZoneSelect
            dashboardName={dashboardName}
            timeZoneFilter={timeZoneFilter}
          />
        }>
        <IconButton
          className="time-zone__icon-button"
          icon={MapClockOutlineIcon}
          size="md"
          appearance="primary"
          disabled={!isAddedDateFilter}
          padding="6px"
          title="Time Zone"
          onClick={() => setIsOpen(!isOpen)}
        />
      </Popover>
    </WrapperItem>
  );
};
